export default __webpack_public_path__ + "static/media/bg-login.44b6b8d4.jpg";